import { Button } from "@material-ui/core"
import { Add } from "@material-ui/icons"
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward"
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward"
import PropTypes from "prop-types"
import ActionBar from "~/components/ActionBar/index.jsx"
import DebouncedSearch from "~/components/DebouncedSearch"
import sortDirectionUtil from "~/utils/sortDirection"
import sortTypeUtil from "~/utils/sortType"
import Box from "../Box"
import PermissionsWrapper from "../PermissionsWrapper"
import useStyles from "./styles"

const AdminActionBar = ({
  buttonName,
  buttonFunc,
  sortOptions,
  sortState,
  setSortState,
  setFilterState,
  placeholder,
  hideSearch,
  children,
  searchInputRef,
}) => {
  const classes = useStyles()
  //change the icon depends of the direction
  const iconFunc = (name) => {
    if (name === sortState.name && sortState.direction === "ASC") {
      return <ArrowUpwardIcon />
    } else if (name === sortState.name && sortState.direction === "DSC") {
      return <ArrowDownwardIcon />
    } else {
      return ""
    }
  }
  return (
    <ActionBar
      elevation={0}
      left={() => (
        <>
          <PermissionsWrapper permissionGroup="admin">
            <Button
              onClick={buttonFunc}
              variant="contained"
              color="secondary"
              startIcon={<Add fontSize="small" />}
            >
              {buttonName}
            </Button>
          </PermissionsWrapper>
          {children}
        </>
      )}
      right={() => (
        <Box display="flex" alignItems="center" height="100%">
          {sortOptions?.map((x) => (
            <Button
              key={x.id}
              color="secondary"
              style={{ margin: "12px" }}
              className={classes.actionButtons}
              onClick={() => {
                let sortType = sortTypeUtil(x.name.toLowerCase())
                setSortState((oldState) => ({
                  name: x.name.toLowerCase(),
                  type: sortType,
                  direction: sortDirectionUtil(
                    oldState?.name,
                    x.name.toLowerCase(),
                    sortState.direction,
                  ),
                }))
              }}
              endIcon={iconFunc(x.name.toLowerCase())}
            >
              {x.name}
            </Button>
          ))}
          {!hideSearch && (
            <DebouncedSearch
              className={classes.search}
              placeholder={placeholder}
              onChange={(value) => setFilterState(value)}
              searchInputRef={searchInputRef}
            />
          )}
        </Box>
      )}
    />
  )
}

AdminActionBar.propTypes = {
  buttonName: PropTypes.string,
  buttonFunc: PropTypes.func,
  sortOptions: PropTypes.array,
  sortState: PropTypes.object,
  setSortState: PropTypes.func,
  setFilterState: PropTypes.func,
  placeholder: PropTypes.string,
  hideSearch: PropTypes.bool,
  children: PropTypes.node,
  searchInputRef: PropTypes.object,
}

export default AdminActionBar
